var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-0.934 -0.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-ios-forward",
    transform: "translate(0.934 0.298)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6423",
    "data-name": "Rectangle 6423",
    width: 20,
    height: 20,
    transform: "translate(0 20) rotate(-90)",
    fill: "#d7b16d",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238539",
    "data-name": "Path 238539",
    d: "M9.818,16.445a.818.818,0,0,1-.63-1.341l3.664-4.384L9.319,6.328A.836.836,0,1,1,10.636,5.3L14.586,10.2a.818.818,0,0,1,0,1.039L10.5,16.151A.818.818,0,0,1,9.818,16.445Z",
    transform: "translate(-2.177 -1.424)",
    fill: "#d7b16d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerLinkArrow);
export default __webpack_public_path__ + "static/media/hamburger_link-arrow.7c497252418ad08a4a3822a00245fa33.svg";
export { ForwardRef as ReactComponent };